import { useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import { Modal } from "./ui";

const toBlob = (src, area, w, h) => new Promise((resolve, reject) => {
  const im = new Image();
  im.onload = () => {
    const c = document.createElement("canvas");
    c.width = w; c.height = h;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#FFFFFF";
    ctx.fillRect(0, 0, w, h);
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(im, area.x, area.y, area.width, area.height, 0, 0, w, h);
    c.toBlob((b) => (b ? resolve(b) : reject(new Error("Falha ao cortar"))), "image/jpeg", 0.92);
  };
  im.onerror = reject;
  im.src = src;
});

// Crops one file at a time to exactly w x h px; onDone(blob|null)
export function ImageCropper({ file, w, h, onDone, index, total }) {
  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [area, setArea] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!file) { setSrc(null); return undefined; }
    const u = URL.createObjectURL(file);
    setSrc(u); setCrop({ x: 0, y: 0 }); setZoom(1);
    return () => { URL.revokeObjectURL(u); };
  }, [file]);

  const confirm = async () => {
    setBusy(true);
    try { onDone(await toBlob(src, area, w, h)); } finally { setBusy(false); }
  };

  return (
    <Modal open={!!file} onClose={() => onDone(null)} title={`Cortar foto ${total > 1 ? `(${index + 1}/${total})` : ""} — ${w}×${h} px`}>
      <div data-testid="image-cropper" className="space-y-4">
        <div className="relative w-full h-[55vh] max-h-[480px] bg-black rounded-lg overflow-hidden">
          {src && <Cropper image={src} crop={crop} zoom={zoom} minZoom={1} maxZoom={4} aspect={w / h} onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={(_, px) => setArea(px)} />}
        </div>
        <div className="flex items-center gap-3">
          <span className="text-xs text-[#A0A0A0]">Zoom</span>
          <input type="range" min={1} max={4} step={0.01} value={zoom} onChange={(e) => setZoom(Number(e.target.value))} className="flex-1 accent-[#008CFF]" data-testid="image-cropper-zoom" />
        </div>
        <p className="text-xs text-[#A0A0A0]">Arraste para posicionar. A foto será salva em {w}×{h} px (proporção 4:5).</p>
        <div className="flex justify-end gap-2">
          <button type="button" className="btn-ghost" onClick={() => onDone(null)} data-testid="image-cropper-skip">Cancelar esta foto</button>
          <button type="button" className="btn-primary" disabled={!area || busy} onClick={confirm} data-testid="image-cropper-confirm">{busy ? "Cortando..." : "Cortar e inserir"}</button>
        </div>
      </div>
    </Modal>
  );
}
